import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-segment-control-item',
  templateUrl: './segment-control-item.component.html',
  styleUrl: './segment-control-item.component.scss'
})
export class SegmentControlItemComponent {
  @Input() text: string = '';
  @Input() active: boolean = false;

  protected classes(): any {
    return {
      'active': !this.active,
    };
  }
}
